import React from 'react';
import cn from 'classnames';

import {useContentCardContext} from '../../ContentCard';

import {IContentCardImagesProps} from './IContentCardImages';

import styles from './ContentCardImages.module.scss';

const ContentCardImages = (props: IContentCardImagesProps) => {
	const {style} = useContentCardContext();

	if (!props.children) {
		return null;
	}

	return (
		<div
			className={cn(
				styles['content-card__images'],
				'content-card__images',
				{
					[styles[`content-card__images--${style}`]]: style,
				}
			)}
		>
			{props.children}
		</div>
	);
};

export default ContentCardImages;
